import {
  SET_TPO_METRICS,
  SET_TPO_USER_LIST,
  SET_TPO_FILTER,
} from 'modules/TPORequests/actions'

const initialState = {
  tpoMetrics: {},
  tpoUserList: {},
  tpoFilterData: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TPO_METRICS:
      return {
        ...state,
        tpoMetrics: action.data,
      }
    case SET_TPO_USER_LIST:
      return {
        ...state,
        tpoUserList: action.data,
      }
    case SET_TPO_FILTER:
      return {
        ...state,
        tpoFilterData: action.data,
      }
    default:
      return state
  }
}
